module.exports = __webpack_public_path__ + "img/云服务云课堂.8f4aae15.jpg";